import React from "react";
import "../../styles/Layout.css";
import "../../styles/Components.css";
import "../../styles/Game.css";

const RestMode = () => {
  return (
    <div className="rest-mode-layout">
      <img
        src={`${process.env.PUBLIC_URL}/assets/img/rest-char.png`}
        alt="Character"
        className="character-image-rest"
      />
    </div>
  );
};

export default RestMode;
